import * as React from 'react';
import { Link } from 'react-router-dom'

export default () => {
	return(
		<header>
			<div><Link to='/' className='logo'>Let's Experiment!</Link></div>
		</header>
	);
}


// WEBPACK FOOTER //
// ./src/components/Header.tsx